import AppRoutes from "./routes/AppRoutes";

// 🔥 Redux
import { Provider } from "react-redux";
import { store } from "./store";

// 🔥 Global Snackbar
import GlobalSnackbar from "./components/common/GlobalSnackbar";
import { useEffect } from "react";

function App() {
  return (
    <Provider store={store}>
      <GlobalSnackbar />
      {/* 🚀 Routes */}
      <AppRoutes />
    </Provider>
  );
}

export default App;
